import { IPlacement } from "@sp-crm/core";
import { LabeledEntityContactDetails } from "components/details-page-v-next/entity-contact-details";
import { AdvancedSearchEntityType } from "generated/graphql";
import React from "react";
import { useTenantSettings } from "store/selectors/settings";
import { ClientBestContactFields } from "./client-best-contact";
import { clientBestContactDetails, clientContactDetails } from "./client-details";
import { ClientInfoForm } from "./client-info-form";

interface ClientDetailsFormProps {
    placement: IPlacement;
    onFieldChange: (fieldName: string, newValue: unknown) => void;
    onFieldChangeMulti: (newValues: Record<string, unknown>) => void;
}

interface ClientDetailsBlockProps extends ClientDetailsFormProps {
    editing: boolean;
}

const ClientDetailsForm: React.FC<ClientDetailsFormProps> = props => {
    const { placement, onFieldChange, onFieldChangeMulti } = props;
    const {
        settings: { showClientFirst },
    } = useTenantSettings();

    const clientInfo = (
        <ClientInfoForm
            placement={placement}
            onFieldChange={onFieldChange}
            onMultiFieldChange={onFieldChangeMulti}
        />
    );
    const bestContact = (
        <ClientBestContactFields
            placement={placement}
            onFieldChangeMulti={onFieldChangeMulti}
        />
    );

    return showClientFirst ? (
        <>
            {clientInfo}
            {bestContact}
        </>
    ) : (
        <>
            {bestContact}
            {clientInfo}
        </>
    );
};

const ClientDetailsSummary: React.FC<{ placement: IPlacement }> = props => {
    const { placement } = props;
    const {
        settings: { showClientFirst },
    } = useTenantSettings();

    const clientInfo = (
        <LabeledEntityContactDetails
            label="Client"
            entityId={placement.id}
            entityType={AdvancedSearchEntityType.Client}
            details={clientContactDetails(placement)}
        />
    );
    const bestContact = (
        <LabeledEntityContactDetails
            label="Best contact"
            entityId={placement.id}
            entityType={AdvancedSearchEntityType.Client}
            details={clientBestContactDetails(placement.bestContactEntity)}
        />
    );

    return showClientFirst ? (
        <>
            {clientInfo}
            {bestContact}
        </>
    ) : (
        <>
            {bestContact}
            {clientInfo}
        </>
    );
};

export const ClientDetailsBlock: React.FC<ClientDetailsBlockProps> = props => {
    const { placement, editing, onFieldChange, onFieldChangeMulti } = props;

    return (
        <div className="@container space-y-2 px-4 pb-3">
            {editing ? (
                <div className="grid max-w-7xl grid-cols-1 items-start gap-2 lg:grid-cols-2 lg:gap-4">
                    <ClientDetailsForm
                        placement={placement}
                        onFieldChange={onFieldChange}
                        onFieldChangeMulti={onFieldChangeMulti}
                    />
                </div>
            ) : (
                <ClientDetailsSummary placement={placement} />
            )}
        </div>
    );
};
